var _path, _circle, _path2, _circle2, _circle3, _circle4, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 244,
    viewBox: "0 0 296 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.5 112L284.336 123.664L296 127.5L284.336 131.336L280.5 143L276.664 131.336L265 127.5L276.664 123.664L280.5 112Z",
    fill: "#FF6058"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 50,
    r: 8,
    stroke: "#FFCB05",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 166L15.8561 178.232C15.9023 179.821 17.1791 181.098 18.7675 181.144L31 181.5L18.7675 181.856C17.1791 181.902 15.9023 183.179 15.8561 184.768L15.5 197L15.1439 184.768C15.0977 183.179 13.8209 181.902 12.2325 181.856L0 181.5L12.2325 181.144C13.8209 181.098 15.0977 179.821 15.1439 178.232L15.5 166Z",
    fill: "#FF6058"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 201,
    r: 3,
    stroke: "#27CA40",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 122,
    r: 122,
    fill: "url(#paint0_linear_2635_20644)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.999,
    cy: 122.001,
    r: 86.7274,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.564 183.726C130.564 185.563 132.054 187.053 133.891 187.053H162.461C164.299 187.053 165.788 185.563 165.788 183.726C165.788 178.674 161.692 174.578 156.64 174.578H139.713C134.66 174.578 130.564 178.674 130.564 183.726Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136.436,
    y: 154.75,
    width: 23.4824,
    height: 5.8706,
    rx: 2.9353,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145.241,
    y: 158.428,
    width: 5.8706,
    height: 20.5471,
    rx: 2.9353,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.676 98.9912C115.676 92.5067 120.933 87.25 127.417 87.25L168.512 87.25C174.996 87.25 180.253 92.5067 180.253 98.9912V120.272C180.253 138.104 165.797 152.56 147.965 152.56C130.132 152.56 115.676 138.104 115.676 120.272V98.9912Z",
    fill: "#FFC130"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.883 112.926V112.926C191.647 115.501 191.693 125.15 184.883 127.602V127.602",
    stroke: "#D9D9D9",
    strokeWidth: 4.40295,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.636 112.447L110.434 112.544C104.04 115.617 104.669 124.919 111.418 127.103V127.103",
    stroke: "#D9D9D9",
    strokeWidth: 4.40295,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.899 56.6934L91 86.9308L147.772 103.592L192.82 64.7155L137.899 56.6934Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.624 92.7902C156.656 92.7902 149.518 102.664 148.695 107.6C148.181 106.264 144.746 103.282 135.119 102.047C125.493 100.813 117.944 104.619 115.372 106.676C114.522 102.655 112.892 95.0888 111.716 90.0071C111.139 87.5107 111.791 84.839 113.655 83.0809C117.292 79.6511 120.547 77.437 123.959 75.6392C133.685 70.5146 144.618 67.4859 155.61 67.6634C164.654 67.8094 170.344 69.6908 173.243 71.4488C174.43 72.169 175.074 73.4521 175.355 74.8122C176.655 81.0921 178.624 91.0266 178.624 92.7902Z",
    fill: "#151515"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102 89V99.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102 98V102",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2635_20644",
    x1: 147,
    y1: 0,
    x2: 147,
    y2: 244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27CA40",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsicon);
export default __webpack_public_path__ + "static/media/congrats icon.db88bfffd66497f15452b161dda0b589.svg";
export { ForwardRef as ReactComponent };